export default function isChromeOrSafari() {
    if (typeof window !== 'undefined') {
        const isSafari = /safari|applewebkit/i.test(navigator.userAgent);
        const isChrome = !!window.chrome && !!window.chrome.webstore;
        return isSafari || isChrome;
    }
    return false;
}



// WEBPACK FOOTER //
// ./app/lib/ui/isChromeOrSafari.js